import { useCallback, useEffect, useRef, useState } from 'react';

import lineEndpoint from '../../../../api/services/lineEndpoint';

export const useFetchPermissionaries = () => {
  const [loading, setLoading] = useState();
  const [permissionaries, setPermissionaries] = useState([]);
  const isMounted = useRef(true);

  const fetchAllPermissionaries = useCallback(async () => {
    setLoading(true);
    if (permissionaries.length === 0) {
      try {
        const response = await lineEndpoint.getAllPermissionaries();
        if (response.status === 200) {
          if (isMounted.current) setPermissionaries(response.data);
        }
      } finally {
        setLoading(false);
      }
    }
    // eslint-disable-next-line
  }, []);

  useEffect(() => {
    fetchAllPermissionaries().catch(console.error);
    return () => {
      isMounted.current = false;
    };
  }, [fetchAllPermissionaries]);

  return {
    loading,
    permissionaries,
  };
};